import type { FaireProductEntity } from "../../entity_types/product";

export const p_7dnrfs5q4q: FaireProductEntity = {
  token: "p_7dnrfs5q4q",
  type: "product",
  name: "Thin Strap Striped Textured Tiered Dress",
  brandToken: "b_3l4cxzzyla",
  brandName: "THML",
  imageUrl:
    "https://cdn.faire.com/fastly/b99707281ccf92918d727a93c73edb295980b843c89ab397c4b66f5352b32f2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c7549ad9e726fc65f16d775620816e885ec7528b5c179e66878a99f2f3b4e4d3.jpeg",
    "https://cdn.faire.com/fastly/7351f418654e39e821557077870387a80acfebd3666c2cc83a1cc0525f4b53ad.jpeg",
    "https://cdn.faire.com/fastly/dce5fc99b29f811a6ede3fba4100d3579bc73bc84e2a31170f3d600d09b481ea.jpeg",
    "https://cdn.faire.com/fastly/12d9270128e6978fc38064e2b04acda96adfeae6c78ed63da2d428d638aedc20.jpeg",
    "https://cdn.faire.com/fastly/bfdff2ca43a8ebb6c1072efbe1251f19f268450fc00132e9c6d0aa29d16062d7.jpeg",
    "https://cdn.faire.com/fastly/23aa4e142cf775e5b75d4fbff76cb65bcac89a2914c018a5fc7ab1cf6016379a.jpeg",
  ],
  priceDollars: 40,
  description:
    'Thin Strap Striped Textured Tiered Dress\r\n.\r\n/ Style Measurements for Size S\r\n/ Designed in USA\r\n - Body Length: 48 in\r\n - Bust Width: 33 in\r\n - Sleeve Length: N/A\r\n.\r\n/ Model Sizes\r\n - Wearing Size S\r\n - Height 5\' 9", Bust 32", Waist 25 1/2", Hips 36"\r\n.\r\n/ Prepack Contents\r\n - In a Pack of XS(1), S(2), M(2), and L(1) per Color Only\r\n.\r\n/ Fabric Content\r\n - WOVEN / 50% Polyester, 50% Cotton',
  tags: [],
  msrpDollars: 92,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:02.785Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
